import { Controller, Menu, Param } from '@tencent/workbench';
import { AddonMallFeature } from './addon-mall-feature';
import { MENU_CONFIGS } from './config';
import { isLogin } from '@src/js/common/utils';
import { getPcInjectedService } from '@framework/workbench/util/injector-service';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { MallType } from './types';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import ua from '@tencent/docs-user-agent';


@Controller({ menuItems: MENU_CONFIGS })
export class AddonMallController {
    private baseAddonService;
    public constructor(private readonly feature: AddonMallFeature) {
        this.getBaseAddonService();
    }

    @Menu('addon-mall-:tab', 'onClick')
    public async clickHandler(@Param('tab') tab: string): Promise<void> {
        await this.getBaseAddonService();
        const onOpen = this.baseAddonService?.openAddonForMall.bind(this.baseAddonService);
        this.feature.openAddonMall(onOpen, tab as MallType);
        this.feature.twdReport(tab as MallType);
    }

    @Menu('addon-mall-:tab', 'shouldDisabled')
    public shouldDisabled(): boolean {
        if (ua.isTencentMeeting) return true;
        const { pptEditorState } = this.getUserPriviledgeService();
        if ((pptEditorState === PPTEditorStateType.EDITABLE && isLogin())
        && !(browser.isPc && browser.isMiniProgram)) {
            return false;
        }
        return true;
    }

    // 云编文档暂时屏蔽掉插件商城，不然用户可以添加云编所不支持的iframe类型插件
    @Menu('addon-mall-:tab', 'shouldHide')
    public shouldHide(): boolean {
        return !(DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.addonUnofficialIframe) ?? true);
    }

    private getBaseAddonService = async () => {
        if (this.baseAddonService) return;
        return import(/* webpackChunkName: "addon" */ '@framework/workbench/common/service/base-addon-service')
            .then((module) => {
                const { BaseAddonService } = module;
                this.baseAddonService = getPcInjectedService(BaseAddonService);
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    };

    private getUserPriviledgeService() {
        return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
            .viewableServiceLayer.userPriviledgeService;
    }
}
